import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4themes_myTheme from "../../theme/am4themes_myTheme";
import * as am4plugins_sliceGrouper from '@amcharts/amcharts4/plugins/sliceGrouper'
import { useRef, useLayoutEffect, useState, useEffect, useCallback } from 'react'
import colors from '../../theme/colors'
am4core.useTheme(am4themes_animated);
am4core.useTheme(am4themes_myTheme);

const styles = {
    chartDiv: () => ({
        width: "100%",
        height: 375
    })
}

const setSliceColors = (slices) => {
    let updatedSlices = slices.map((slice) => {
        let colorCode
        if (slice.category.includes('positive')) {
            colorCode = colors.POSITIVE
        } else if (slice.category.includes('negative')) {
            colorCode = colors.NEGATIVE
        } else if (slice.category.includes('neutral')) {
            colorCode = colors.NEUTRAL
        }
        return {
            ...slice,
            color: am4core.color(colorCode)
        }
    })

    return updatedSlices
}

function AmPieChart({ resultSet, amchartId }) {
    const chart = useRef(null);

    let chartData = resultSet.chartPivot()

    /**
     * @function hideZero function to hide slice labels that have a value of 0%
     * @param {Object} ev
     */
    const hideZero = useCallback((ev) => {
        if (ev.target.dataItem && (ev.target.dataItem.values.value.percent <= 0)) {
            ev.target.hide();
        }
        else {
            ev.target.show();
        }
    })

    /**
     * @function setLabels function to configure the label settings of the slices
     * @param {Object} series
     */
    const setLabels = useCallback((series) => {
        series.alignLabels = false;
        let labelsTemplate = series.labels.template
        labelsTemplate.radius = am4core.percent(-40);
        labelsTemplate.disabled = true;
        labelsTemplate.events.on("ready", hideZero);
        labelsTemplate.text = "{value.percent.formatNumber('#.0')}%"
        labelsTemplate.fontSize = 10;

        labelsTemplate.adapter.add("radius", function (radius, target) {
            if (target.dataItem && (target.dataItem.values.value.percent < 10)) {
                return 0;
            }
            return radius;
        });
        return series
    })

    /** 
     * @function groupSmallSlices function to group small valued slices into 1 slice called "Other"
     * @param {Object} series 
     */
    const groupSmallSlices = useCallback((series) => {
        var grouper = series.plugins.push(new am4plugins_sliceGrouper.SliceGrouper());
        //grouper.threshold = 2;
        grouper.limit = 4 //leave the first 4 and group the rest
        grouper.groupName = "Other";
        grouper.clickBehavior = "zoom";
    })

    /** 
     * @function configureLegend function to configure legend settings 
     * @param {Object} legend
     */
    const configureLegend = useCallback((legend) => {
        legend.position = 'bottom'
        // legend.maxWidth = 145
        legend.valueLabels.template.disabled = true
        // legend.maxHeight = 30
        legend.scrollable = true

        let legendLabelsTemplate = legend.labels.template
        legendLabelsTemplate.text = "{category}";
        legendLabelsTemplate.fontSize = 10;
        legendLabelsTemplate.truncate = false;
        legendLabelsTemplate.wrap = true;
        legend.valueLabels.template.fontSize = 12;

        let marker = legend.markers.template.children.getIndex(0);
        marker.cornerRadius(12, 12, 12, 12);
        let markerTemplate = legend.markers.template;
        markerTemplate.width = 15;
        markerTemplate.height = 15;
    })
    useLayoutEffect(() => {
        let x = am4core.create(`chartdiv-pie-${resultSet.seriesNames()[0]/* .title */}-${amchartId}`, am4charts.PieChart);
        resultSet.seriesNames().map(sItem => {
            let series = x.series.push(new am4charts.PieSeries());
            series.dataFields.value = sItem.key;
            series.dataFields.category = "category";

            // if the chart data does not have an "Other" group of its own
            if (
                !chartData
                    .find(item => item.category.toLowerCase() == 'other')
            )
                groupSmallSlices(series)

            series = setLabels(series)
            series.slices.template.propertyFields.fill = "color"
        })

        //Donut
        //x.innerRadius = am4core.percent(30);

        x.legend = new am4charts.Legend();

        configureLegend(x.legend)

        // set the data
        x.data = chartData
        x.logo.disabled = true
        chart.current = x;

        return () => {
            x.dispose();
        };
    }, []);

    return (
        <div id={`chartdiv-pie-${resultSet.seriesNames()[0]/* .title */}-${amchartId}`} style={styles.chartDiv()}></div>
    );
}

export default AmPieChart;
